/**
 * Cart Notification & Cart Badge
 */

if (typeof CartNotification === 'undefined') {

class CartNotification {
  constructor() {
    this.notification = document.getElementById('cart-notification');
    this.cartLink = document.querySelector('[data-cart-link]');
    this.cartBadge = document.querySelector('.he-cart-badge');
    this.autoHideDelay = 3000;
    this.init();
  }

  init() {
    // Listen for cart additions via fetch API
    this.hookIntoCartForms();

    // Also listen for Shopify's cart:add event
    document.addEventListener('cart:add', (e) => {
      this.show(e.detail?.variant || null, e.detail?.product || null);
    });

    // Close button
    if (this.notification) {
      const closeBtn = this.notification.querySelector('.he-cart-notification__close');
      closeBtn.addEventListener('click', () => this.hide());

      // Close on click outside
      document.addEventListener('click', (e) => {
        if (!this.notification.contains(e.target) && this.notification.classList.contains('he-cart-notification--visible')) {
          // Don't hide if clicking on another add to cart button
          if (!e.target.closest('.he-pdp__add-to-cart') && !e.target.closest('.product-form__submit')) {
            this.hide();
          }
        }
      });
    }
  }

  hookIntoCartForms() {
    // Intercept Add to Cart form submissions
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form.dataset.cart === 'form' || form.classList.contains('product-form__form')) {
        // Let the form submit first, then show notification
        form.addEventListener('cart:refresh', () => {
          this.showFromCart();
        });
      }
    });

    // Also try to intercept on button click
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[name="add"]');
      if (btn && !btn.disabled) {
        // Show loading state
        this.showLoading(btn);
      }
    });
  }

  showFromCart() {
    // Fetch cart to get the last added item
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items && cart.items.length > 0) {
          const lastItem = cart.items[cart.items.length - 1];
          this.show(lastItem.variant_id, lastItem);
        }
      });
  }

  show(variantId, product) {
    if (!this.notification) return;

    // Update cart badge
    this.updateCartBadge();

    // If we have product info, update the notification content
    if (product) {
      this.updateNotificationContent(product, variantId);
    }

    // Show notification
    this.notification.classList.add('he-cart-notification--visible');

    // Auto-hide after delay
    if (this.autoHideTimer) clearTimeout(this.autoHideTimer);
    this.autoHideTimer = setTimeout(() => {
      this.hide();
    }, this.autoHideDelay);
  }

  showLoading(btn) {
    // Add loading class to button
    btn.classList.add('loading');
    btn.dataset.loading = 'true';
  }

  hide() {
    if (!this.notification) return;
    this.notification.classList.remove('he-cart-notification--visible');
  }

  updateNotificationContent(product, variantId) {
    const imageEl = this.notification.querySelector('#notification-product-image');
    const titleEl = this.notification.querySelector('#notification-product-title');
    const variantEl = this.notification.querySelector('#notification-product-variant');
    const priceEl = this.notification.querySelector('#notification-product-price');

    // Get product image
    if (product.featured_image) {
      imageEl.src = product.featured_image;
      imageEl.alt = product.title;
    } else if (product.image) {
      imageEl.src = product.image;
      imageEl.alt = product.title;
    } else {
      imageEl.src = '';
      imageEl.alt = '';
    }

    // Title
    titleEl.textContent = product.title || '';

    // Variant
    if (product.variant_title && product.variant_title !== 'Default Title') {
      variantEl.textContent = product.variant_title;
      variantEl.style.display = 'block';
    } else {
      variantEl.style.display = 'none';
    }

    // Price
    if (product.price) {
      priceEl.textContent = this.formatMoney(product.price);
    }
  }

  updateCartBadge() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const badge = document.querySelector('.he-cart-badge');
        if (badge) {
          const count = cart.item_count || 0;
          badge.textContent = count;
          badge.style.display = count > 0 ? 'flex' : 'none';
        }

        // Also update Shopify cart link if it exists
        const cartLink = document.querySelector('.he-cart-link');
        if (cartLink) {
          const countSpan = cartLink.querySelector('.cart-count');
          if (countSpan) {
            countSpan.textContent = cart.item_count;
          }
        }
      })
      .catch(err => console.error('Error updating cart badge:', err));
  }

  formatMoney(cents) {
    const money = (cents / 100).toFixed(2).replace('.', ',');
    return money + ' €';
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.cartNotification = new CartNotification();
});

// Re-initialize on Shopify section load
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    window.cartNotification = new CartNotification();
  });
}

} // end typeof CartNotification guard